<template lang="html">
  <div>
    <v-form v-model="formularioValido" ref="form">
      <v-container>

        <!-- Número de alunos de graduação participantes -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field-integer
              label='Número de alunos de graduação participantes*'
              v-model="projetoPesquisa.numAlunosGraduacao"
              v-bind:properties="{
                rules: [...obrigatorio,...numerico]
              }"
            />
          </v-flex>
        </v-layout>

        <!-- Número de alunos de especialização participantes -->
        <v-layout row>
          <v-flex xs12>
            <v-text-field-integer
              label='Número de alunos de especialização participantes*'
              v-model="projetoPesquisa.numAlunosEspecializacao"
              v-bind:properties="{
                rules: [...obrigatorio,...numerico]
              }"
            />
          </v-flex>
        </v-layout>

        <!-- Possui vínculo com a iniciação científica -->
        <v-layout row>
          <v-flex xs2>
            <v-radio-group 
              class="v-radio-group_label" 
              label="Possui vínculo com a iniciação científica*"
              v-model="projetoPesquisa.vinculoIniciacaoCientifica"
            >
              <v-radio label="Sim" :value="true"></v-radio>
              <v-radio label="Não" :value="false"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <!-- Possui interface com outras áreas -->
        <v-layout row>
          <v-flex xs2>
            <v-radio-group 
              class="v-radio-group_label" 
              label="Possui interface com outras áreas*"
              v-model="projetoPesquisa.interfaceOutrasAreas"
            >
              <v-radio label="Sim" :value="true"></v-radio>
              <v-radio label="Não" :value="false"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <!-- Áreas de interface com o projeto -->
        <v-layout row v-if="projetoPesquisa.interfaceOutrasAreas === true">
          <v-flex xs12>
            <label>Áreas de interface com o projeto*</label>
          </v-flex>
        </v-layout>

        <!-- Área de interface "Desenvolvimento Tecnológico" -->
        <v-layout row v-if="projetoPesquisa.interfaceOutrasAreas === true">
          <v-flex xs2>
            <v-checkbox
              v-model="projetoPesquisa.areaDesenvTec"
              label="Desenvolvimento Tecnológico"
            >
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Área de interface "Ensino" -->
        <v-layout row v-if="projetoPesquisa.interfaceOutrasAreas === true">
          <v-flex xs2>
            <v-checkbox
              v-model="projetoPesquisa.areaEnsino"
              label="Ensino"
            >
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Área de interface "Extensão" -->
        <v-layout row v-if="projetoPesquisa.interfaceOutrasAreas === true">
          <v-flex xs2>
            <v-checkbox
              v-model="projetoPesquisa.areaExtensao"
              label="Extensão"
            >
            </v-checkbox>
          </v-flex>
        </v-layout>

        <!-- Área de interface "Outras" -->
        <v-layout row v-if="projetoPesquisa.interfaceOutrasAreas === true">
          <v-flex xs2>
            <v-checkbox
              v-model="projetoPesquisa.areaOutros"
              label="Outras"
            >
            </v-checkbox>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs9>
            <v-text-field
              v-if="projetoPesquisa.areaOutros === true"
              label='Especifique*'
              v-model="projetoPesquisa.especAreaOutros"
              counter="100"
              :rules="[...obrigatorio,...max100caracteres]"
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>    
        </v-layout>  

        <br>

      </v-container>
    </v-form>

    <v-divider></v-divider>

    <v-card-actions>

      <!-- Botão "Cancelar" -->
      <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>
      
      <v-spacer></v-spacer>
      
      <!-- Botão "Salvar" -->
      <v-btn color="primary" :disabled="!formularioValido" @click="editarProjetoPesquisa()">Salvar</v-btn>

    </v-card-actions>
  </div>
</template>

<script>
  import projetos from '@/utils/projetos'
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa'],
    data: () => ({
      formularioValido: false,
      projetoPesquisa: {
        numAlunosGraduacao: null,
        numAlunosEspecializacao: null
      },
      obrigatorio: [v => !!v || 'Este campo é obrigatório'],
      max20caracteres: [v => v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres'],
      max100caracteres: [v => v.length <= 100 || 'Este campo pode ter no máximo 100 caracteres'],
      max300caracteres: [v => v.length <= 300 || 'Este campo pode ter no máximo 300 caracteres'],
      max400caracteres: [v => v.length <= 400 || 'Este campo pode ter no máximo 400 caracteres'],
      max2000caracteres: [v => v.length <= 2000 || 'Este campo pode ter no máximo 2000 caracteres'],
      numerico: [
        (input) => !isNaN(input) || 'Este campo é numérico',
        (input) => (input.length === 0 || Number(input) >= 0) || 'Este campo não pode ser negativo',
        (input) => Number.isInteger(Number(input)) || 'Este campo deve ser um número inteiro'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Edita um projeto de pesquisa.
      editarProjetoPesquisa: function () {
        // Limpa áreas de interface com o projeto de pesquisa.
        if (this.projetoPesquisa.interfaceOutrasAreas === false) {
          this.projetoPesquisa.areaDesenvTec = false
          this.projetoPesquisa.areaEnsino = false
          this.projetoPesquisa.areaExtensao = false
          this.projetoPesquisa.areaOutros = false
          this.projetoPesquisa.especAreaOutros = null
        }

        // Limpa especificação de outra área de interface com o projeto de pesquisa.
        if (this.projetoPesquisa.areaOutros === false) {
          this.projetoPesquisa.especAreaOutros = null
        }

        // Chama o endpoint para editar o projeto de pesquisa.
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' })
        projetos.putProjetoPesquisa(this.idProjetoPesquisa, this.projetoPesquisa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetoPesquisaOutrasInformacoes', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' })
        })
      },

      // Redireciona para a página de visualização da aba "Outras Informações".
      cancelar: function () {
        this.$router.push({name: 'ProjetoPesquisaOutrasInformacoes', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
      }
    },
    mounted () {
      // Carrega o projeto de pesquisa.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
      projetos.getProjetoPesquisa(this.idProjetoPesquisa)
      .then(response => {
        this.projetoPesquisa = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }

  .v-radio-group_label {
    margin-top: 0;
  }
</style>


// WEBPACK FOOTER //
// editar-outras-informacoes.vue?071e3e6b